
// Stat Card for Detail View
const StatCard = ({ label, value, color = "blue", trend }) => {
    const colorClasses = {
        blue: "text-black",
        green: "text-black",
        orange: "text-black",
        purple: "text-black",
        red: "text-black",
        cyan: "text-black"
    };

    return (
        <div className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">{label}</span>
                {trend && (
                    <span className={`text-xs font-semibold text-black`}>
                        {trend > 0 ? '+' : ''}{trend}%
                    </span>
                )}
            </div>
            <div className={`text-2xl font-bold text-black`}>
                {value}
            </div>
        </div>
    );
};

export default StatCard;